import Vue from 'vue'
import App from './App.vue'
import { List, Button, Input, Modal, FormModel, Skeleton, Spin, message, Popconfirm, Pagination } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'
import AsyncComputed from 'vue-async-computed'
import '@aws-amplify/ui-vue';
import Amplify from 'aws-amplify';
import awsconfig from '../aws-exports';
Amplify.configure(awsconfig);

Vue.use(List);
Vue.use(Button);
Vue.use(Input);
Vue.use(Modal);
Vue.use(FormModel);
Vue.use(Skeleton);
Vue.use(Spin);
Vue.use(Popconfirm);
Vue.use(Pagination);
Vue.prototype.$message = message

Vue.use(AsyncComputed);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
